import type { BeforeErrorHook, HTTPError } from 'ky';
import { HTTP_HEADERS } from '../../../../auth/const';
import type { ErrorPayload } from '../../../consts/error';
import type { FetchOptions } from '../../types';
import { UAFetchError } from '../../UAFetchError';
import { getResponseData, isServer } from '../../utils';

async function handleError(args: {
  response: Response;
  url: string;
  options: FetchOptions;
  request: HTTPError['request'];
  kyOptions: HTTPError['options'];
}) {
  const { response, url, options, request, kyOptions } = args;
  const responseData = (await getResponseData(response, options)) as Partial<ErrorPayload> | string;
  let serverRequestId = '';
  if (isServer()) {
    const { headers: nextHeaders } = await import('next/headers');
    const header = await nextHeaders();
    serverRequestId = header.get(HTTP_HEADERS.UIServerRequestId) ?? '';
  }

  let messageTitle = 'Failed to fetch',
    errorId = '';
  if (typeof responseData === 'object') {
    messageTitle = responseData.errorMessage || responseData.message || messageTitle;
    errorId = responseData.errorId ?? errorId;
  }

  throw new UAFetchError({
    request,
    response,
    options: kyOptions,
    message: `[UAFetchError] ${messageTitle}${serverRequestId ? ` ${serverRequestId}` : ''} ${url} : [${errorId}]`,
    status: response.status,
    statusText: response.statusText,
    url,
    payload: typeof responseData === 'object' ? responseData : { message: responseData },
  });
}

export const getLogBeforeErrorHook = (fetchOptions: FetchOptions): BeforeErrorHook => {
  return async (error) => {
    const { response, request, options } = error;
    await handleError({
      response,
      request,
      url: request.url,
      kyOptions: options,
      options: fetchOptions,
    });
    return error;
  };
};
